import PropTypes from 'prop-types';
import Link from 'next/link';

import { getProductPageRedirectionInfos } from '@/utils/productCardUtils';

const ProductCardLink = ({ children, id, seoKeyword, partnumber, storeConf, isSpirit, ariaLabel }) => (
  <Link
    aria-label={ariaLabel}
    {...getProductPageRedirectionInfos({ _id: id, seoKeyword, isSpirit }, { partnumber }, storeConf)}
  >
    {children}
  </Link>
);

ProductCardLink.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  seoKeyword: PropTypes.string.isRequired,
  partnumber: PropTypes.string,
  storeConf: PropTypes.object,
  isSpirit: PropTypes.bool,
  ariaLabel: PropTypes.string
};

export default ProductCardLink;
